<template>
  <div>
    <div v-if="match.havePlayingXI">
      <div class="center-title center"><h2 class="center">Playing XI</h2></div>
      <section class="fullwidth">
         <div :class="[item[1]]" v-for="item in [
          ['a', 'part-first'],
          ['b', 'part-last'],]"
          :key="item.$index">
          <div v-if="match.teams[item[0]].match && match.teams[item[0]].match.playing_xi"
            v-for="(playerKey,index) in match.teams[item[0]].match.playing_xi"
            :key="playerKey">
            <span
              class="clickable playing-xi-player"
              @click="onPlayerSelected(playerKey)">
              <span class="info" v-if="item[0] === 'a'">
                <span v-if="match.teams[item[0]].match.captain === playerKey">(captain) </span>
                <span v-if="match.teams[item[0]].match.keeper === playerKey">(Wicket keeper) </span>
                <span class="highlight" v-if="match.players[playerKey].role && match.players[playerKey].role.value == 'keeper'">(Wk) </span>
                <span class="highlight" v-else>({{match.players[playerKey].role.value.slice(0, 3) | capitalise}}) </span>
              </span>
              <span v-if="match.players[playerKey] && item[0] === 'a'">{{match.players[playerKey].name}}.{{index + 1}}</span>
              <span v-if="match.players[playerKey] && item[0] === 'b'">{{index + 1}}.{{match.players[playerKey].name}}</span>
              <span class="info" v-if="item[0] === 'b'">
                <span class="highlight" v-if="match.players[playerKey].role && match.players[playerKey].role.value == 'keeper'"> (Wk) </span>
                <span class="highlight" v-else> ({{match.players[playerKey].role.value.slice(0, 3) | capitalise}}) </span>
                <span v-if="match.teams[item[0]].match.captain === playerKey">(captain)</span>
                <span v-if="match.teams[item[0]].match.keeper === playerKey">(Wicket keeper)</span>
              </span>
            </span>
          </div>
         </div>
      </section>
    </div>
    <div v-if="match.haveXFactor">
      <div class="center-title center"><h2 class="center">X Factor</h2></div>
      <section class="fullwidth">
        <div :class="[item[1]]" v-for="item in [
          ['a', 'part-first'],
          ['b', 'part-last'],]"
          :key="item.$index">
          <div v-if="match.teams[item[0]].match && match.teams[item[0]].match.x_factor_substitutes">
            <h5>{{match.teams[item[0]].match.x_factor_substitutes.length}} players</h5>
            <div
              v-for="role in match.xFactorSubstituteByRole(item[0])"
              v-if="role.players.length"
              :key="role.name">
              <h5 class="top-space silent">{{role.name}}</h5>
              <ul>
                <li v-for="playerKey in role.players" :key="playerKey">
                  <span
                    class="clickable"
                    @click="onPlayerSelected(playerKey)">
                    {{match.players[playerKey].name}}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div v-if="match.havePlayers">
      <div class="center-title center"><h2 class="center">All Players</h2></div>
      <section class="fullwidth">
        <div :class="[item[1]]" v-for="item in [
          ['a', 'part-first'],
          ['b', 'part-last'],]"
          :key="item.$index">
          <h5>{{match.teams[item[0]].match.players.length}} players</h5>
          <div
            v-for="role in match.teamPlayersByRole(item[0])"
            v-if="role.players.length"
            :key="role.name">
            <h5 class="top-space silent">{{role.name}}</h5>
            <ul>
              <li v-for="playerKey in role.players" :key="playerKey">
                <span
                  class="clickable"
                  @click="onPlayerSelected(playerKey)">
                  <span :class="{ 'changing': match.players[playerKey].isValidSeasonRole, 'alert': !match.players[playerKey].isValidSeasonRole}"
                    v-if="match.players[playerKey].isSeasonalRoleDifferent && item[0] === 'a'"
                  >
                    <span v-if="match.players[playerKey].role">
                      (also {{match.players[playerKey].role.value}})
                    </span>
                    <span v-else>
                      (Invalid Role)
                    </span>
                  </span>
                  {{match.players[playerKey].name}}
                  <span :class="{ 'changing': match.players[playerKey].isValidSeasonRole, 'alert': !match.players[playerKey].isValidSeasonRole}"
                    v-if="match.players[playerKey].isSeasonalRoleDifferent && item[0] === 'b'"
                  >
                    <span v-if="match.players[playerKey].role">
                      (also {{match.players[playerKey].role.value}})
                    </span>
                    <span v-else>
                      (Invalid Role)
                    </span>
                  </span>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>

    <div v-if="!appState.appKind.isWorkflow">
      <div class="center-title center"><h2 class="center">Team Stats</h2></div>
      <section class="fullwidth">
        <div :class="[item[1]]" v-for="item in [
          ['a', 'part-first'],
          ['b', 'part-last'],]"
          :key="item.$index">
          <div>
            <router-link :to="{ name: isMetric ? 'MetricCricketTeam' : 'cricketTeam', params: {key: match.teams[item[0]].key}}">
              {{match.teams[item[0]].short_name}} Stats
            </router-link>
          </div>
          <div>
            <router-link :to="{ name: isMetric ? 'MetricSeasonTeam' : 'cricketSeasonTeam', params:{key:match.season.key, teamkey:match.teams[item[0]].match.season_team_key}}">
              {{match.teams[item[0]].short_name}} Season Stats
            </router-link>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    match: Object,
    isMetric: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onPlayerSelected (playerKey) {
      this.$emit('playerSelected', playerKey)
    }
  }
}
</script>
